import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { EXBotPromptFields, IMessageResponseDto } from 'src/types'

class XService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  generateAndPostTweet(promptName: EXBotPromptFields) {
    return this.post<IMessageResponseDto, { promptName: EXBotPromptFields }>(`x/generate`, {
      promptName,
    })
  }

  replyToHashtagTweet() {
    return this.post<IMessageResponseDto, any>(`x/hashtag-reply`, {})
  }

  replyToMentionsTweet() {
    return this.post<IMessageResponseDto, any>(`x/mentions-reply`, {})
  }

  replyToFollowedUsersTweet() {
    return this.post<IMessageResponseDto, any>(`x/followed-reply`, {})
  }

  updateXTrends() {
    return this.put<IMessageResponseDto, any>(`x/trends`, {})
  }

  trackfyCollectDataFromUsersTweetsAndReply() {
    return this.post<IMessageResponseDto, {}>(`x/trackfy-data-and-reply`, {})
  }

  trackfyCollectDataFromTweetAndReply(tweetId: string) {
    return this.post<IMessageResponseDto, {}>(`x/trackfy-data-and-reply-single`, {
      tweet_id: tweetId,
    })
  }
}

export const xService = new XService()
export default XService
